import type { RevenueConcentrationDTO } from "../models/revenueConcentrationDto";
import type { RevenueConcentrationEntity } from "../../domain/entities/RevenueConcentrationEntity";

export function revenueConcentrationDtoToEntity(
  dto: RevenueConcentrationDTO
): RevenueConcentrationEntity {
  return {
    totalRevenueAmount: Number(dto.totalRevenueAmount) ?? 0,
    unbilledRevenueAmount:
      dto.unbilledRevenueAmount != null &&
      Number.isFinite(Number(dto.unbilledRevenueAmount))
        ? Number(dto.unbilledRevenueAmount)
        : 0,
    currencySymbol: dto.currencySymbol ?? "₹",
    customers: (dto.customers ?? []).map((c) => ({
      name: c.name ?? "Customer",
      amount: Number(c.amount) ?? 0,
      percent: Number(c.percent) ?? 0,
    })),
    monthLabel: dto.monthLabel ?? "",
  };
}
